import React from "react";
import { FaChartBar, FaCalendarAlt, FaTrophy, FaUsers } from "react-icons/fa";
import { ImStatsDots } from "react-icons/im";
import { MdPlace, MdAdminPanelSettings } from "react-icons/md";
import { IoIosLogOut } from "react-icons/io";
import { IoSettingsSharp } from "react-icons/io5";

const iconMap = {
  FaChartBar: FaChartBar,
  FaTrophy: FaTrophy,
  FaCalendarAlt: FaCalendarAlt,
  ImStatsDots: ImStatsDots,
  FaUsers: FaUsers,
  MdPlace: MdPlace,
  IoSettingsSharp: IoSettingsSharp,
  MdAdminPanelSettings: MdAdminPanelSettings,
  IoIosLogOut: IoIosLogOut,
};

const LinkItem = ({ href, icon, text, onClick }) => {
  const IconComponent = iconMap[icon];

  return (
    <li>
      <a
        href={href}
        className="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700"
        onClick={onClick}
      >
        {IconComponent && <IconComponent className="mr-3" />}
        <span className="flex-1 me-3">{text}</span>
      </a>
    </li>
  );
};

export default LinkItem;
